import React from 'react'
import { useHistory } from 'react-router'

import Button from './Button'

type ButtonRouterLinkProps = {
  to: string
  onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => any
} & React.ComponentProps<typeof Button>

const ButtonRouterLink: React.FC<ButtonRouterLinkProps> = ({
  to,
  onClick,
  ...props
}) => {
  const history = useHistory()

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()

    if (onClick) {
      onClick(e)
    }

    history.push(to)
  }

  return <Button onClick={handleClick} {...props} />
}

export default ButtonRouterLink
